import tokens from './tokens';
import keywords from './keywords';

const emit = require("./emit");
const api: string = 'https://interpreter.pumpkinspicelatte.org/code'; 

function id (elm: any) {
  let id = elm.getAttribute('id');
  if (!id && !!elm.getAttribute('class')) {
    id = elm.parentNode.getAttribute('title');
  } else if (!id) {
    id = elm.getAttribute('title')
  } return Number(id);
}

function edit (elm: any) {
  return elm.children[elm.children.length - 1];
}

function line (index: string) {
  return document.getElementById(index);
}

function token (elm: any) {
  if (elm.getAttribute('class')) {
    return elm.getAttribute('title');
  } return null;
}

function os () {
  let OSName = 0;
  if (navigator.appVersion.indexOf("Win") > -1) OSName = 1;
  if (navigator.appVersion.indexOf("Mac") > -1) OSName = 2;
  if (navigator.appVersion.indexOf("X11") > -1) OSName = 3;
  if (navigator.appVersion.indexOf("Linux") > -1) OSName = 4;
  return OSName;
}

export {
  emit, id, os, api, edit, line, token, tokens, keywords
};
